// src/App.js
import React from "react";
import AppNavigator from "./AppNavigator";

export default function App() {
  return <AppNavigator />; 
}